export const A_PARAM_LIVE_SESSION_START = "start";
export const A_PARAM_LIVE_SESSION_PAUSE = "pause";
export const A_PARAM_LIVE_SESSION_STOP = "stop";
export const A_PARAM_LIVE_SESSION_RESUME = "resume";
